import React, { useRef, useState } from 'react'
import IdleTimer from 'react-idle-timer'
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from '@appkit4/react-components/esm/modal/ModalFooter';
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types';

const idleTimeLimit = process.env.REACT_APP_IDLE_TIME

let IdleTimerComponent = (props) => {
    const history = useHistory();
    let idleTimerRef = useRef(null)
    let sessionTimeOutRef = useRef(null)
    let [modalVisible, setModalVisible] = useState(false)

    let idleHandler = () => {
        setModalVisible(true)
        sessionTimeOutRef.current = setTimeout(handleConfirmLogOut, 1000*10)
    }

    let handleConfirmLogOut = () => {
        setModalVisible(false)
        history.push("/");
        sessionStorage.removeItem("roleId");
        sessionStorage.removeItem("loggedIn");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("orgId");
        clearTimeout(sessionTimeOutRef.current)
    }

    let handelKeepLogin = () => {
        setModalVisible(false)
        clearTimeout(sessionTimeOutRef.current)
    }

    return (
        <div>
            <Modal
                className="baseline-modal-showcase"
                visible={modalVisible}
                onCancel={handelKeepLogin}
                bodyStyle={{ maxHeight: "280px" }}
                footerStyle={{ paddingTop: "8px", marginTop: "5px"}}
                modalStyle={{ width: "30rem" ,maxHeight:"fit-content" }}
            >
                    <div className="row">
                        <div className="col-12 text-center mb-3">
                            <div className="a-fw-500 a-apply-theme-font-default-white">You have been idle for a while! You will be logged out soon.</div>
                        </div>
                    </div>
                <ModalFooter>
                            <button
                                type="button"
                                className="cancel-button w-200p"
                                onClick={handleConfirmLogOut}
                            >
                                Log me out
                            </button>

                            <button
                                type="button"
                                className="save-button m-l-2 w-200p"
                                onClick={handelKeepLogin}
                            >
                                Keep me signed in
                            </button>
                </ModalFooter>
            </Modal>
            <IdleTimer ref={idleTimerRef} timeout={idleTimeLimit} onIdle={idleHandler}>{props.children}</IdleTimer>
        </div>
    )
}
IdleTimerComponent.propTypes = {
    children:PropTypes.any,
  
  }

export default IdleTimerComponent;